'use client';

import React from 'react';
import MobileMenuLinkItem from './mobileMenuLinkItem';
import PlusIcon from '../../atoms/icons/plus';
import { LinkWrapper } from '../../../utils/link';
import useHideOnSite from '../../../hooks/useLanguageFilter';

const MobileMenuItem = ({
  nav,
  index,
  visibleIndex,
  setVisible,
  trackingParent,
}) => {
  const toggleVisibility = () => {
    setVisible(index);
  };

  return useHideOnSite(nav.hide_on_site) ? null : (
    <div className={`px-4 md:px-12 mb-4`} key={nav._uid}>
      <div className="flex items-center " key={nav._uid + '_link'}>
        <LinkWrapper
          link={nav.link}
          className="text-lg no-underline opacity-75 hover:opacity-100"
          key={nav.uid + 'wrapper'}
          trackingId={`${trackingParent}-${nav.text}`}
        >
          {nav.text}
        </LinkWrapper>
        {nav.image?.filename && (
          <img
            src={nav.image.filename}
            className="max-h-5 ml-2"
            alt={nav.text}
          />
        )}
        {nav.sub_links && nav.sub_links.length > 0 && (
          <button
            className="no-underline opacity-100 rounded-full bg-yellow-60 hover:bg-yellow-40 w-8 h-8 ml-4 flex items-center justify-center"
            onClick={toggleVisibility}
          >
            {visibleIndex === index ? (
              <PlusIcon inverted={true} />
            ) : (
              <PlusIcon inverted={false} />
            )}
          </button>
        )}
      </div>
      {nav.sub_links && nav.sub_links.length > 0 && (
        <div
          className={`${
            visibleIndex === index
              ? 'flex flex-wrap h-auto visible delay-300'
              : 'h-0 invisible delay-0'
          } transition-all overflow-y-auto scrollbars-hide`}
          key={nav._uid + '_sub'}
        >
          {nav.sub_links.map((item) => {
            return (
              <div
                key={item._uid}
                className={`${
                  visibleIndex === index
                    ? 'opacity-100 delay-0'
                    : 'opacity-0 delay-300'
                } flex w-1/2 sm:w-1/3 transition-opacity  `}
              >
                {item.component === 'link_item_group' ? (
                  <div key={item._uid + '_0'}>
                    {item.sub_links.map((i) => (
                      <div key={i._uid}>
                        <MobileMenuLinkItem
                          item={i}
                          trackingParent={`${trackingParent}-${nav.text}`}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div key={item._uid + '_sublink'} className="w-full">
                    <MobileMenuLinkItem
                      item={item}
                      trackingParent={`${trackingParent}-${nav.text}`}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MobileMenuItem;
